import { Link } from 'react-router-dom'
import cx from 'classnames'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'

import { Button } from 'components/Button/Button'
import { ReactComponent as OverflowIcon } from 'assets/icons/breadcrumbOverflow.svg'

import { FolderBreadcrumbProps } from 'common/Breadcrumbs/components/FolderBreadcrumb/FolderBreadcrumb'
import Styles from './OverflowPopover.module.scss'

interface OverflowPopoverProps {
  popoverItems: FolderBreadcrumbProps[]
}

export const OverflowPopoverLink = ({ popoverItems }: OverflowPopoverProps) => {
  return (
    <>
      <DropdownTrigger placement="bottom-start">
        <Button variant="tertiary" size="md">
          <OverflowIcon />
        </Button>
        {(close) => (
          <div className={Styles.overflowPopover}>
            {popoverItems.map((project) => {
              return (
                <Link key={project.title} className={Styles.overflowPopoverRow} to={project.to}>
                  <div className={cx(Styles.breadcrumb, { [Styles.defaultProject]: !!project.defaultFolder })}>
                    {project.icon}
                    <span className={Styles.text}>{project.title}</span>
                  </div>
                </Link>
              )
            })}
          </div>
        )}
      </DropdownTrigger>
      <div className={Styles.divider}>/</div>
    </>
  )
}

export const OverflowPopover = ({ popoverItems }: OverflowPopoverProps) => {
  return (
    <>
      <div className={Styles.divider}>/</div>
      <DropdownTrigger placement="bottom-start">
        <Button variant="tertiary" size="md" className={Styles.overflowTrigger}>
          <OverflowIcon />
        </Button>
        {(close) => (
          <div className={Styles.overflowPopover}>
            {popoverItems.map((project) => {
              return (
                <div key={project.title} className={Styles.overflowPopoverRow} onClick={project.onClick}>
                  <div className={cx(Styles.breadcrumb, { [Styles.defaultProject]: !!project.defaultFolder })}>
                    {project.icon}
                    <span className={Styles.text}>{project.title}</span>
                  </div>
                </div>
              )
            })}
          </div>
        )}
      </DropdownTrigger>
    </>
  )
}
